module.exports = __webpack_public_path__ + "img/Icon ionic-ios-arrow-round-forward.1fa2d23d.svg";